import React from 'react'
import { mount } from 'enzyme'

import { EtranLanding }  from '../EtranLanding'

describe('EtranLanding', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      loanId:15262,
      paycheck_protection: true,
      etran_via_api: true,
      cavirs_result_screen: true,
      data: {
        loan: {
          appNumber: 1234,
          business: {
            rid: 123
          },
          etranResultsDocument: {
            rid: 123
          },
          etran:{
            sbaStatus: "Approved By SBA",
            errorStatus: 'SBA error',
            etranScore: 600,
            plpAuthorizationNumber: 1234567,
            externalId: 'sdf2321',
          }
        }
      },
      document: {
        rid: 123,
        files: []
      },
      initLoading: true,
      updateEtranInfo: jest.fn(),
      submitEtranApi: jest.fn(),
    }
    wrapper = mount(<EtranLanding {...props} />)
    instance = wrapper.instance()
  })

  describe('#handleEtranInfoSuccess', () => {
    describe('should redirect to caivr page when cavirs_result_screen is true', () => {
      it('should go to caivr url', () => {
        const mockWindowLocation = { href: '' };

        Object.defineProperty(global.window, 'location', {
          value: mockWindowLocation,
        });

        instance.setState({ appNumber:1234 })
        instance.handleEtranInfoSuccess();

        expect(mockWindowLocation.href).toBe('/admin/loans/1234/caivr?stage=5');
      })
    })

    describe('should reload to etran page when cavirs_result_screen is false', () => {
      it('reload should have been called', () => {
        props.cavirs_result_screen = false;
        const mockWindowLocation = { href: '' };

        Object.defineProperty(global.window, 'location', {
          value: mockWindowLocation,
        });

        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        global.window.location.reload = jest.fn();
        instance.handleEtranInfoSuccess();

        expect(global.window.location.reload).toHaveBeenCalled();
      })
    })
  })

  describe('#isEtranAvailableForLoan', () => {
    describe('when paycheck protection is true', () => {
      it('should return true ', () => {
          expect(instance.isEtranAvailableForLoan(props.data.loan)).toBeTruthy()
      })
    })
    describe('when paycheck protection is false and etran is null', () => {
      it('should return true ', () => {
        props.paycheck_protection = false
        props.data.loan.etran = null
        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        expect(instance.isEtranAvailableForLoan(props.data.loan)).toBeFalsy()
      })
    })
  })

  describe('#isErrorStatus', () => {
    describe('when sba_satus is not error', () => {

      it('should return false ', () => {
          expect(instance.isErrorStatus(props.data.loan.etran)).toBeFalsy()
      })
    })
    describe('when sba_status is error', () => {
      it('should return true ', () => {
        props.data.loan.etran.sbaStatus = 'error'
        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        expect(instance.isErrorStatus(props.data.loan.etran)).toBeTruthy()
      })
    })
  })

  describe('#getErrorStatus', () => {
    describe('when sba_satus is not error', () => {

      it('should return error string inside a list ', () => {
          const error_status_list=[]
          error_status_list.push(props.data.loan.etran.errorStatus)
          expect(instance.getErrorStatus(props.data.loan.etran.errorStatus)).toEqual(error_status_list)
      })
    })
  })

  describe('#validInput', () => {
    describe('when fields have data and doc is uploaded', () =>{
      it('should return true', ()=>{
        const data = { etran_score: '1234', score_date: '2024-12-12' }
        props.document.files = [1]
        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().validInput(data)).toBeTruthy()
      })
    })

    describe('#when fields have data but doc is not uploaded', () =>{
      it('should return false', ()=>{
        const data = { etran_score: '1234', score_date: '2024-12-12' }
        props.document.files = []
        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().validInput(data)).toBeFalsy()
      })
    })

    describe('#when fields do not have data and doc isuploaded', () =>{
      it('should return false', ()=>{
        const data = {}
        props.document.files = [1]
        wrapper = mount(<EtranLanding {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().validInput(data)).toBeFalsy()
      })
    })
  })
})
